import { downloadExcel, getReport } from './petitions';

export const biSDK = {
    petitions: {
        downloadExcel,
        getReport,
    },
};
